import { render } from "./VetCustomerCard.vue?vue&type=template&id=45b32744&scoped=true"
import script from "./VetCustomerCard.vue?vue&type=script&lang=js"
export * from "./VetCustomerCard.vue?vue&type=script&lang=js"

import "./VetCustomerCard.vue?vue&type=style&index=0&id=45b32744&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b32744"]])

export default __exports__